import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import Service from "../Service/http";
import ReactTable from 'react-table-6';
import "react-table-6/react-table.css";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import withFixedColumns from 'react-table-hoc-fixed-columns';
import 'react-table-hoc-fixed-columns/lib/styles.css'
import Dropdown from 'react-bootstrap/Dropdown';
import Stack from 'react-bootstrap/Stack';
import { VscCloudDownload } from "react-icons/vsc"
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import * as xlsx from "xlsx";
const ReactTableFixedColumns = withFixedColumns(ReactTable);
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


function SiteHandles(prop) {
  let service = new Service();
  const [searchParams, setSearchParams] = useSearchParams()

  const initialLoadComplete = useRef(false);
  let [sitesOptions, SetSitesOptions] = useState([]);
  let [ AllBatches, SetAllBatches ] = useState([]);
  const defaultBatch = searchParams.get("batch")
  let [ batch , setBatch] = useState(defaultBatch ?? undefined);
  let [batchData, setBatchData] = useState([])
  let [PageSize, SetPageSize] = useState(50)
  let [PageSizeOption, SetPageSizeOption] = useState([5,10,20,25,50,100])
  let [loading, SetLoading] = useState(false);
  let [filteredSites, setfilteredSites ] = useState([]);
  let [wrongHandles, SetWrongHandles] = useState(false);
  const sites = ["CODECHEF", "CODEFORCES", "LEETCODE", "INTERVIEWBIT", "HACKERRANK", "HACKEREARTH", "SPOJ", "GEEKSFORGEEKS", "VJUDGE", "MENTORPICK"]

  function BuildCSV(){

    const jsonData = batchData

    // Defined the order of columns
    const columnOrder = ["no", "name", "user_id", "college","roll_number", "email", "batches", "CODECHEF", "CODEFORCES", "LEETCODE", "MENTORPICK"];

    // Mapping the keys of the jsonData to ensure the columns are ordered as per columnOrder
    const orderedData = jsonData.map((item) => {
      const orderedItem = {};
      columnOrder.forEach((column) => {
        orderedItem[column] = item[column] !== undefined ? item[column] : "";
      });
      return orderedItem;
    });

    orderedData.forEach((item) => {
      for(let key in item) {
        if(sites.includes(key)) {
          if(item[key].split(',').length > 1) {
            item[key] = item[key].split(',')[1];
          }
        }
      }
    });

    const date = new Date();
    const date_options = { weekday: undefined, year: 'numeric', month: 'long', day: 'numeric' };
    const download_title = batch + ' HANDLES ' + date.toLocaleDateString(undefined, date_options) + ' ' + date.toLocaleTimeString('en-US');
    //setting the file name based on current date and time
    const fileName =  download_title.split(' ').join('-');

    // Convert JSON to worksheet
    const ws = xlsx.utils.json_to_sheet(orderedData, { header: columnOrder });

    // Create a workbook
    const wb = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, "Sheet 1");

    // Save the workbook to a file
    xlsx.writeFile(wb, `${fileName}.xlsx`);

  }
  
  function PaginationUpdate(){
    let Datalength = batchData.length;
   
    if(Datalength === 0 || Datalength === null){
      SetPageSizeOption([5, 10, 15, 25, 50])
    }
    else{
    let pageOptions = []
    let defaultOptions = [5,10,20,25,50,100];
    defaultOptions.forEach(item => {
      const cur = Number(item);
      if(cur <= Datalength){
          pageOptions.push(cur)
      }
    })
    let num = 200;
    while(Number(num) <= Datalength){
      pageOptions.push(Number(num));
      num += 100;
    }
    if(pageOptions[pageOptions.length - 1] != Datalength){
      pageOptions.push(Number(Datalength));
    }
    SetPageSizeOption(pageOptions);
  }
  }

  function processData(batch_name){
   
        SetLoading(true);
        service
        .post("api/handles/" + batch_name, { filteredSites, wrongHandles})
        .then((json) => {
          setBatchData(json);
          SetPageSize(Math.max(10, Math.min(50, json?.length)))
          SetLoading(false);
        }).catch((error) => {
          console.error(error);
          SetLoading(false);
        })
      
  }

  useEffect(() => {
    if (!initialLoadComplete.current) {
      const getData = async () => {
        try {
          const [siteOptions, batches] = await Promise.all([
            service.get("api/sites/options"),
            service.get("api/batches"),
          ]);
          SetSitesOptions(["All Sites", ...siteOptions]);
          SetAllBatches(batches.batches);
        } catch (err) {
          console.error(err)
        } finally {
          initialLoadComplete.current = true;
        }
      };

      getData();
    }
  }, []);

  useEffect(() => {
    PaginationUpdate();
  }, [ batchData])

  useEffect(() => {
    if (batch)
      processData(batch);
  }, [filteredSites, batch, wrongHandles]);

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <Stack
          className="col-md-2 mx-auto"
          direction="horizontal"
          style={{ width: "500px" }}
          gap={2}
        >
          <Dropdown style={{ size: "xs", display: "inline" }}>
            <Dropdown.Toggle variant="primary" id="dropdown-basic">
              {batch ?? "Select Batch"}
            </Dropdown.Toggle>

            <Dropdown.Menu className="scrollable-menu">
              <Dropdown.Item
                active={batch == "All batches"}
                style={{ textAlign: "center", fontWeight: "bolder" }}
                onClick={() => {
                  setBatch("All batches");
                  setSearchParams("batch=All batches");
                }}
              >
                All batches
              </Dropdown.Item>
              {AllBatches && AllBatches.length > 0 && AllBatches.map((batch_name) => {
                  return (
                    <Dropdown.Item
                      key={batch_name}
                      active={batch_name == batch}
                      style={{ textAlign: "center", fontWeight: "bolder" }}
                      onClick={() => {
                        setBatch(batch_name);
                        setSearchParams(`batch=${batch_name}`)
                      }}
                    >
                      {batch_name}
                    </Dropdown.Item>
                  );
                })
              }
            </Dropdown.Menu>
          </Dropdown>

          <div className="autocomplete-container">
            <Autocomplete
              multiple
              disablePortal
              disableCloseOnSelect
              id="checkboxes-tags-demo"
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              options={
                filteredSites.includes("All Sites")
                  ? ["All Sites"]
                  : sitesOptions
              }
              onChange={(event, newValue) => {
                setfilteredSites([...newValue, "GRAND TOTAL"]);

              }}
              renderInput={(params) => (
                <TextField {...params} label="Select Sites" />
              )}
            />
          </div>

          <div className="form-check form-switch text-center">
            <input
              className="form-check-input text-center "
              type="checkbox"
              checked={wrongHandles}
              onChange={(e) => {
                SetWrongHandles(e.target.checked);
              }}
            />
            <label className="text-muted form-check-label">wrong/empty user handles</label>
          </div>

          <VscCloudDownload
            data-bs-toggle="tooltip"
            title="Download Batch Handles"
            data-bs-placement="bottom"
            size={40}
            style={{
              display: "inline",
              cursor: "pointer",
              position: "absolute",
              right: 10,
              zIndex: 100,
            }}
            onClick={() => {
              BuildCSV();
            }}
          />
        </Stack>
      </div>
      {batchData && batchData.length > 0 ?
      <ReactTableFixedColumns
        data={batchData}
        style={{
          textAlign: "center",
          fontWeight: "bolder",
          fontSize: "16px",
          height: "auto",
        }}
        pageSize={PageSize}
        pageSizeOptions={PageSizeOption}
        minRows={5}
        loading={loading}
        loadingText={"Loading Handles..."}
        onPageSizeChange={(pageSize, pageIndex) => {
          SetPageSize(pageSize);
        }}
        renderTotalPagesCount={(num) => {
          if (!isFinite(num) || isNaN(num)) {
            num = 1;
          }
          // SetFinalPage(num);
          if (num === 0) {
            return 1;
          }
          return num;
        }}
        columns={[
          {
            Header: "USER DETAILS",
            fixed: "left",
            columns: [
              {
                Header: "No",
                accessor: "no",
                width: 50,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background: rowInfo ? "#0F9ADC" : "",
                    },
                  };
                },
              },
              {
                Header: "Name",
                accessor: "name",
                width: 250,
                Cell: (e) => (
                  <a
                    style={{ color: "white", textDecoration: "underline" }}
                    target="_blank"
                    href={"/coding/profile/" + e.original.user_id}
                  >
                    {" "}
                    {e.value}{" "}
                  </a>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background: rowInfo ? "#0F9ADC" : "",
                    },
                  };
                },
              },
              {
                Header: "Roll No",
                accessor: "roll_number",
                width: 150,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background: rowInfo ? "#0F9ADC" : "",
                    },
                  };
                },
              },
            ],
          },
          {
            Header: "SITES HANDLE",
            columns: [
              {
                show: (filteredSites.length > 0)?(filteredSites.includes("CODECHEF") || filteredSites.includes("All Sites")):sitesOptions.includes("CODECHEF"),
                Header: "Codechef",
                accessor: "CODECHEF",
                Cell: (e) => (
                  <a
                    style={{
                      color: e?.value?.split(",")?.length ? "white" : "black",
                    }}
                    target="_blank"
                    href={
                      "https://codechef.com/users/" + e.value?.split(",")[1]
                    }
                  >
                    {" "}
                    {e?.value?.split(",")?.length
                      ? e.value?.split(",")[1]
                      : "Not Filled"}{" "}
                  </a>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background:
                        rowInfo?.row?.CODECHEF?.split(",")?.length &&
                        rowInfo?.row?.CODECHEF?.split(",")[0] == "true"
                          ? "#1AAD03"
                          : rowInfo?.row?.CODECHEF?.split(",")?.length
                          ? "red"
                          : "",
                    },
                  };
                },
                width: 180,
              },
              {
                show: (filteredSites.length > 0)?(filteredSites.includes("CODEFORCES") || filteredSites.includes("All Sites")):sitesOptions.includes("CODEFORCES"),
                Header: "Codeforces",
                accessor: "CODEFORCES",
                Cell: (e) => (
                  <a
                    style={{
                      color: e?.value?.split(",")?.length ? "white" : "black",
                    }}
                    target="_blank"
                    href={
                      "https://codeforces.com/profile/" + e.value?.split(",")[1]
                    }
                  >
                    {" "}
                    {e?.value?.split(",")?.length
                      ? e.value?.split(",")[1]
                      : "Not Filled"}{" "}
                  </a>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background:
                        rowInfo?.row?.CODEFORCES?.split(",")?.length &&
                        rowInfo?.row?.CODEFORCES?.split(",")[0] == "true"
                          ? "#1AAD03"
                          : rowInfo?.row?.CODEFORCES?.split(",")?.length
                          ? "red"
                          : "",
                    },
                  };
                },
                width: 180,
              },
              {
                show: (filteredSites.length > 0)?(filteredSites.includes("LEETCODE") || filteredSites.includes("All Sites")):sitesOptions.includes("LEETCODE"),
                Header: "Leetcode",
                accessor: "LEETCODE",
                Cell: (e) => (
                  <a
                    style={{
                      color: e?.value?.split(",")?.length ? "white" : "black",
                    }}
                    target="_blank"
                    href={"https://leetcode.com/" + e.value?.split(",")[1]}
                  >
                    {" "}
                    {e?.value?.split(",")?.length
                      ? e.value?.split(",")[1]
                      : "Not Filled"}{" "}
                  </a>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background:
                        rowInfo?.row?.LEETCODE?.split(",")?.length &&
                        rowInfo?.row?.LEETCODE?.split(",")[0] == "true"
                          ? "#1AAD03"
                          : rowInfo?.row?.LEETCODE?.split(",")?.length
                          ? "red"
                          : "",
                    },
                  };
                },
                width: 180,
              },
              {
                show: (filteredSites.length > 0)?(filteredSites.includes("INTERVIEWBIT") || filteredSites.includes("All Sites")):sitesOptions.includes("INTERVIEWBIT"),
                Header: "Interviewbit",
                accessor: "INTERVIEWBIT",
                Cell: (e) => (
                  <a
                    style={{
                      color: e?.value?.split(",")?.length ? "white" : "black",
                    }}
                    target="_blank"
                    href={
                      "https://www.interviewbit.com/profile/" +
                      e.value?.split(",")[1]
                    }
                  >
                    {" "}
                    {e?.value?.split(",")?.length
                      ? e.value?.split(",")[1]
                      : "Not Filled"}{" "}
                  </a>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background:
                        rowInfo?.row?.INTERVIEWBIT?.split(",")?.length &&
                        rowInfo?.row?.INTERVIEWBIT?.split(",")[0] == "true"
                          ? "#1AAD03"
                          : rowInfo?.row?.INTERVIEWBIT?.split(",")?.length
                          ? "red"
                          : "",
                    },
                  };
                },
                width: 180,
              },
              {
                show: (filteredSites.length > 0)?(filteredSites.includes("HACKERRANK") || filteredSites.includes("All Sites")):sitesOptions.includes("HACKERRANK"),
                Header: "Hackerrank",
                accessor: "HACKERRANK",
                Cell: (e) => (
                  <a
                    style={{
                      color: e?.value?.split(",")?.length ? "white" : "black",
                    }}
                    target="_blank"
                    href={
                      "https://www.hackerrank.com/" + e.value?.split(",")[1]
                    }
                  >
                    {" "}
                    {e?.value?.split(",")?.length
                      ? e.value?.split(",")[1]
                      : "Not Filled"}{" "}
                  </a>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background:
                        rowInfo?.row?.HACKERRANK?.split(",")?.length &&
                        rowInfo?.row?.HACKERRANK?.split(",")[0] == "true"
                          ? "#1AAD03"
                          : rowInfo?.row?.HACKERRANK?.split(",")?.length
                          ? "red"
                          : "",
                    },
                  };
                },
                width: 180,
              },
              {
                show: (filteredSites.length > 0)?(filteredSites.includes("HACKEREARTH") || filteredSites.includes("All Sites")):sitesOptions.includes("HACKEREARTH"),
                Header: "Hackerearth",
                accessor: "HACKEREARTH",
                Cell: (e) => (
                  <a
                    style={{
                      color: e?.value?.split(",")?.length ? "white" : "black",
                    }}
                    target="_blank"
                    href={
                      "https://www.hackerearth.com/@" + e.value?.split(",")[1]
                    }
                  >
                    {" "}
                    {e?.value?.split(",")?.length
                      ? e.value?.split(",")[1]
                      : "Not Filled"}{" "}
                  </a>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background:
                        rowInfo?.row?.HACKEREARTH?.split(",")?.length &&
                        rowInfo?.row?.HACKEREARTH?.split(",")[0] == "true"
                          ? "#1AAD03"
                          : rowInfo?.row?.HACKEREARTH?.split(",")?.length
                          ? "red"
                          : "",
                    },
                  };
                },
                width: 180,
              },
              {
                show: (filteredSites.length > 0)?(filteredSites.includes("SPOJ") || filteredSites.includes("All Sites")):sitesOptions.includes("SPOJ"),
                Header: "Spoj",
                accessor: "SPOJ",
                Cell: (e) => (
                  <a
                    style={{
                      color: e?.value?.split(",")?.length ? "white" : "black",
                    }}
                    target="_blank"
                    href={
                      "https://www.spoj.com/users/" + e.value?.split(",")[1]
                    }
                  >
                    {" "}
                    {e?.value?.split(",")?.length
                      ? e.value?.split(",")[1]
                      : "Not Filled"}{" "}
                  </a>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background:
                        rowInfo?.row?.SPOJ?.split(",")?.length &&
                        rowInfo?.row?.SPOJ?.split(",")[0] == "true"
                          ? "#1AAD03"
                          : rowInfo?.row?.SPOJ?.split(",")?.length
                          ? "red"
                          : "",
                    },
                  };
                },
                width: 180,
              },
              {
                show: (filteredSites.length > 0)?(filteredSites.includes("GEEKSFORGEEKS") || filteredSites.includes("All Sites")):sitesOptions.includes("GEEKSFORGEEKS"),
                Header: "Geeksforgeeks",
                accessor: "GEEKSFORGEEKS",
                Cell: (e) => (
                  <a
                    style={{
                      color: e?.value?.split(",")?.length ? "white" : "black",
                    }}
                    target="_blank"
                    href={
                      "https://auth.geeksforgeeks.org/user/" +
                      e?.value?.split(",")[1] +
                      "/profile"
                    }
                  >
                    {" "}
                    {e?.value?.split(",")?.length
                      ? e.value?.split(",")[1]
                      : "Not Filled"}{" "}
                  </a>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background:
                        rowInfo?.row?.GEEKSFORGEEKS?.split(",")?.length &&
                        rowInfo?.row?.GEEKSFORGEEKS?.split(",")[0] == "true"
                          ? "#1AAD03"
                          : rowInfo?.row?.GEEKSFORGEEKS?.split(",")?.length
                          ? "red"
                          : "",
                    },
                  };
                },
                width: 180,
              },
              {
                show: (filteredSites.length > 0)?(filteredSites.includes("VJUDGE") || filteredSites.includes("All Sites")):sitesOptions.includes("VJUDGE"),
                Header: "Vjudge",
                accessor: "VJUDGE",
                Cell: (e) => (
                  <a
                    style={{
                      color: e?.value?.split(",")?.length ? "white" : "black",
                    }}
                    target="_blank"
                    href={"https://vjudge.net/user/" + e?.value?.split(",")[1]}
                  >
                    {" "}
                    {e?.value?.split(",")?.length
                      ? e.value?.split(",")[1]
                      : "Not Filled"}{" "}
                  </a>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background:
                        rowInfo?.row?.VJUDGE?.split(",")?.length &&
                        rowInfo?.row?.VJUDGE?.split(",")[0] == "true"
                          ? "#1AAD03"
                          : rowInfo?.row?.VJUDGE?.split(",")?.length
                          ? "red"
                          : "",
                    },
                  };
                },
                width: 180,
              },
              {
                show: (filteredSites.length > 0)?(filteredSites.includes("MENTORPICK") || filteredSites.includes("All Sites")):sitesOptions.includes("MENTORPICK"),
                Header: "Mentorpick",
                accessor: "MENTORPICK",
                Cell: (e) => (
                  <a
                    style={{
                      color: e?.value?.split(",")?.length ? "white" : "black",
                    }}
                    target="_blank"
                    href={
                      "https://mentorpick.com/profile/" +
                      e?.value?.split(",")[1]
                    }
                  >
                    {" "}
                    {e?.value?.split(",")?.length
                      ? e.value?.split(",")[1]
                      : "Not Filled"}{" "}
                  </a>
                ),
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background:
                        rowInfo?.row?.MENTORPICK?.split(",")?.length &&
                        rowInfo?.row?.MENTORPICK?.split(",")[0] == "true"
                          ? "#1AAD03"
                          : rowInfo?.row?.MENTORPICK?.split(",")?.length
                          ? "red"
                          : "",
                    },
                  };
                },
                width: 180,
              },
            ],
          },
        ]}
        className="-highlight text-dark h5"
      />
    : !loading ? <h2 className="text-center pt-5">No Batch Selected..</h2> : <h2 className="text-center pt-5">Loading..</h2>
    }
    </div>
  );
}

export default SiteHandles;